import React from 'react';
import { TextNote } from 'page/Application/ManageNotificationList/component/Form/styled';

const FormNote = ({ text }) => {
  return <TextNote>{text}</TextNote>;
};

export default FormNote;
